// src/Components/Auth/LoginModal.js
import React, { useState } from 'react';
import { auth, firestore } from '../../firebase'; // Zorg ervoor dat je Firestore (firestore) hier importeert
import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore"; // Importeer Firestore functies
import Modal from './Modal/Modal';
import InlogForm from './InlogForm/InlogForm';
import { useNavigate } from 'react-router-dom';

const LoginModal = ({ isOpen, onClose, setRegisterOpen }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            // Haal de gebruikersrol op uit Firestore
            const userDoc = await getDoc(doc(firestore, 'users', user.uid));
            if (userDoc.exists()) {
                const userData = userDoc.data();
                const userRole = userData.role;

                // Toon een melding met de rol van de gebruiker
                alert(`Ingelogd als: ${userRole}`);

                // Navigeer naar het dashboard na succesvol inloggen
                navigate('/'); 
            } else {
                setError('Gebruikersgegevens niet gevonden');
            }

            onClose();
        } catch (error) {
            setError(`Fout bij inloggen: ${error.message}`);
        }
    };

    if (!isOpen) return null;

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <InlogForm
                email={email}
                setEmail={setEmail}
                password={password}
                setPassword={setPassword}
                onLogin={handleLogin}
                error={error}
                setRegisterOpen={setRegisterOpen}
            />
        </Modal>
    );
};

export default LoginModal;
